import { render, staticRenderFns } from "./ClashRoyaleAccount.vue?vue&type=template&id=1a29ae48&lang=pug"
import script from "./ClashRoyaleAccount.vue?vue&type=script&lang=js"
export * from "./ClashRoyaleAccount.vue?vue&type=script&lang=js"
import style0 from "./ClashRoyaleAccount.vue?vue&type=style&index=0&id=1a29ae48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports